"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var CodepenEmbedScriptTagBuilder_1 = __importDefault(require("./CodepenEmbedScriptTagBuilder"));
var ReactCodepenBody_1 = __importDefault(require("./ReactCodepenBody"));
var ReactCodepen = /** @class */ (function (_super) {
    __extends(ReactCodepen, _super);
    function ReactCodepen(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { loaded: false, loading: true, error: undefined };
        _this.scriptTagBuilder = new CodepenEmbedScriptTagBuilder_1.default()
            .setAsync(true)
            .withOnLoadHandler(_this.handleScriptLoad.bind(_this))
            .withOnErrorHandler(_this.handleScriptError.bind(_this));
        return _this;
    }
    ReactCodepen.prototype.componentDidMount = function () {
        this._mounted = true;
        if (this.props.shouldLoadScript) {
            // load the codepen embed script
            this.scriptTagBuilder.appendTo(document.body);
        }
    };
    ReactCodepen.prototype.componentWillUnmount = function () {
        this._mounted = false;
    };
    ReactCodepen.prototype.render = function () {
        var _a = this.props, height = _a.height, themeId = _a.themeId, title = _a.title, user = _a.user, hash = _a.hash, defaultTab = _a.defaultTab, preview = _a.preview, version = _a.version, loader = _a.loader;
        return (React.createElement("div", { "data-height": height, "data-theme-id": themeId, "data-slug-hash": hash, "data-default-tab": defaultTab, "data-user": user, "data-embed-version": version, "data-pen-title": title, "data-preview": preview, className: "codepen" },
            React.createElement(ReactCodepenBody_1.default, { user: user, hash: hash, loader: loader, title: title, isLoaded: this.isLoaded(), isLoading: this.state.loading, error: this.state.error })));
    };
    ReactCodepen.prototype.isLoaded = function () {
        return this.props.overrideAsLoaded || this.state.loaded;
    };
    ReactCodepen.prototype.handleScriptLoad = function () {
        // do not do anything if the component is already unmounted.
        if (!this._mounted)
            return;
        this.setState({
            loaded: true,
            loading: false
        });
    };
    ReactCodepen.prototype.handleScriptError = function () {
        if (!this._mounted)
            return;
        this.setState({
            error: 'Failed to load the pen'
        });
    };
    ReactCodepen.defaultProps = {
        defaultTab: 'css,result',
        height: 300,
        preview: true,
        themeId: 'dark',
        version: 2,
        shouldLoadScript: true
    };
    return ReactCodepen;
}(react_1.Component));
exports.default = ReactCodepen;
//# sourceMappingURL=ReactCodepen.js.map